import React, { useState } from 'react';
import { IconButton, Popover, Box, TextField, Button, Typography, Tooltip } from '@mui/material';
import KeyIcon from '@mui/icons-material/Key';
import { getLlmApiKey, setLlmApiKey } from '../../utils/llmApiKey';

/**
 * AR9b: lets the user enter their own LLM API key. Stored in localStorage and
 * sent as X-LLM-API-Key, overriding the backend-configured key. A key dot shows
 * when one is set.
 */
const ApiKeySettings = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = useState(getLlmApiKey());
  const [hasKey, setHasKey] = useState(Boolean(getLlmApiKey()));

  const open = (e) => { setValue(getLlmApiKey()); setAnchorEl(e.currentTarget); };
  const close = () => setAnchorEl(null);

  const save = () => { setLlmApiKey(value.trim()); setHasKey(Boolean(value.trim())); close(); };
  const clear = () => { setLlmApiKey(''); setValue(''); setHasKey(false); };

  return (
    <>
      <Tooltip title={hasKey ? 'LLM API key set (overrides server key)' : 'Set your own LLM API key'}>
        <IconButton size="small" onClick={open} aria-label="LLM API key settings" sx={{ color: hasKey ? 'success.main' : 'inherit' }}>
          <KeyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Popover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <Box sx={{ p: 2, width: 320 }}>
          <Typography variant="subtitle2" gutterBottom>Your LLM API key</Typography>
          <Typography variant="caption" sx={{ display: 'block', mb: 1, color: 'text.secondary' }}>
            Stored only in this browser; sent with chat requests to override the
            server key. Leave empty to use the server default.
          </Typography>
          <TextField
            type="password" size="small" fullWidth autoComplete="off"
            placeholder="sk-or-..." value={value}
            onChange={(e) => setValue(e.target.value)}
            slotProps={{ htmlInput: { 'aria-label': 'LLM API key' } }}
          />
          <Box sx={{ mt: 1.5, display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
            <Button size="small" onClick={clear} disabled={!hasKey && !value}>Clear</Button>
            <Button size="small" variant="contained" onClick={save}>Save</Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default ApiKeySettings;
